<template>
	<div class="input-group input-group-sm flex-nowrap">
		<select2 :id="id" :disabled="loading" :name="name" :title="title">
			<option v-for="oportunidad in oportunidades" v-bind:value="oportunidad.CODIGO_OPORTUNIDAD">
				{{oportunidad.CODIGO_OPORTUNIDAD}} - {{oportunidad.DESCRIPCION_OPORTUNIDAD}}
			</option>
		</select2>
		<div class="input-group-append" v-if="oportunidades.length==0">
			<button class="btn btn-outline-secondary" type="button"  v-on:click.prevent="getData" tabindex="-1">
				<span v-if="loading">
	    			<i class="fas fa-spinner fa-pulse"></i>
				</span>
				<i class="material-icons" style="font-size: 18px;" v-else>update</i>
			</button>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['value', 'disabled', 'id', 'name', 'title'],

		mounted(){
			this.getData();
			var vm = this
            
			$(this.$el)
			.children()
			.val(this.value)
            .on('change', function () {
                vm.$emit('input', this.value)
            });
		},

		data(){
			return {
				oportunidades: [],
				loading: false,
			}
		},

		methods: {
			getData: function(){
				this.loading = true;
				var url = 'api/catalogos/oportunidades';

				axios.get(url)
				.then(response => {
					this.oportunidades = response.data;
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
					$(this.$el).children('select').val(this.value).trigger('change');
				});
			},
		},

		watch: {
            value: function (value) {
                $(this.$el).children('select').val(value).trigger('change');
            },

            disabled: function(value){
            	$(this.$el).children('select').attr('disabled', value);
            	if (value) {
            		$(this.$el).find('a').hide();
            	}else{
            		$(this.$el).find('a').show();
            	}
            },

            id: function(value){
            	$(this.$el).children('select').attr('id', value);
            	$(this.$el).children('label').attr('for', value);
            }
        },
	}
</script>